import { Unionize } from "./generic";

/**
 * The supported currency codes in FOND
 */
export const Currency = ["USD", "GBP"] as const;
export type Currency = Unionize<typeof Currency>;

type CurrencyRecord<T extends Currency = Currency> = {
  [K in T]: {
    /**
     * The currency code
     */
    Code: K; // constrain the Code so that it must be the same as the key K
    /**
     * The currency symbol
     */
    Symbol: string;
    /**
     * The currency label to be displayed in the UI
     */
    Name: string;
  };
};

export const CurrencyDetails: CurrencyRecord = {
  USD: { Code: "USD", Symbol: "$", Name: "US Dollar" },
  GBP: { Code: "GBP", Symbol: "£", Name: "British Pound" },
};
